export interface UseFavoritesCookieReturn {
	cookie: Readonly<Ref<string | undefined>>;
	get: () => string | undefined;
	refresh: (userId?: string) => string;
}

/**
 * Cookie to force CloudFront cache miss for favorite toggles.
 */
export function useFavoritesCookie(): UseFavoritesCookieReturn {
	const maxAge = 60 * 60 * 24 * 30;

	// Avaliação em runtime do NODE_ENV
	// Para Safari iOS em contextos first-party, usa sameSite: 'lax' com secure: true
	// sameSite: 'none' só é necessário para cookies cross-site e pode ser bloqueado pelo Safari iOS
	const isDevelopment = process.env.NODE_ENV === 'development';

	const cookie = useCookie<string | undefined>('favorites', {
		maxAge,
		sameSite: 'lax', // Sempre 'lax' para compatibilidade com Safari iOS
		secure: !isDevelopment, // Avaliado em runtime
		httpOnly: false,
		expires: new Date(Date.now() + maxAge * 1000),
		default: () => undefined
	});

	function get() {
		return cookie.value;
	}

	function refresh(userId?: string) {
		const prefix = userId ? `u${userId}` : 'g';
		const ts = Date.now().toString(36);
		const token = `${ts}-${prefix}`;
		cookie.value = token;
		return token;
	}

	return { cookie: readonly(cookie), get, refresh };
}
